import React from 'react';

import { PromptTurn } from '@type/chat';

interface PromptTurnNavigationProps {
  turns: PromptTurn[];
  activeTurnIndex: number;
  onPrevious: () => void;
  onNext: () => void;
}

const PromptTurnNavigation: React.FC<PromptTurnNavigationProps> = ({
  turns,
  activeTurnIndex,
  onPrevious,
  onNext,
}) => {
  if (turns.length === 0) {
    return null;
  }

  const safeActiveTurnIndex = activeTurnIndex >= 0 ? activeTurnIndex : turns.length - 1;
  const activeTurn = turns[safeActiveTurnIndex]!;

  return (
    <div className='pointer-events-none absolute right-4 top-4 z-10 hidden md:block'>
      <div className='pointer-events-auto w-64 rounded-xl border border-gray-200 bg-white/90 p-3 shadow-lg backdrop-blur dark:border-gray-700 dark:bg-gray-900/90'>
        <div className='text-[11px] font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400'>
          Prompt turns
        </div>
        <div className='mt-2 text-sm font-medium text-gray-900 dark:text-gray-100'>
          {safeActiveTurnIndex + 1} / {turns.length}
        </div>
        <div className='mt-2 text-xs text-gray-600 dark:text-gray-300'>
          {activeTurn.preview}
        </div>
        <div className='mt-3 flex gap-2'>
          <button
            className='btn btn-small btn-neutral flex-1 disabled:cursor-not-allowed disabled:opacity-50'
            onClick={onPrevious}
            disabled={safeActiveTurnIndex <= 0}
          >
            Previous
          </button>
          <button
            className='btn btn-small btn-neutral flex-1 disabled:cursor-not-allowed disabled:opacity-50'
            onClick={onNext}
            disabled={safeActiveTurnIndex >= turns.length - 1}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default PromptTurnNavigation;